module.exports = __webpack_public_path__ + "img/79.ac236ad9.jpg";